import commonStrings from 'owa-strings/owa-mini-common-strings';
import MailModule from './MailModule';
import React from 'react';
import strings from 'owa-strings/owa-mini-common-strings';
import { AriaLiveWrapper } from 'mini-accessibility';
import { BrowserRouter as Router } from 'react-router-dom';
import { getMailCampaignObjects } from 'mini-mail-campaign-view/lib/util/miniMailCampaignObjects';
import { getMailPath } from 'owa-url';
import { lazyRegisterMailWorkflowConfigs } from 'mini-mail-workflow-config';
import { MiniNavigationContextProvider } from 'mini-navigation/lib/MiniNavigationContext';
import { observer } from 'mobx-react-lite';
import { RouteStateContextProvider } from 'route-state-utils/lib/context/RouteStateContext';
import { useRefreshMailListOnVisibilityChange } from './useRefreshMailListOnVisibilityChange';
import { useRegisterWorkflowConfigs } from 'mini-app-context/lib/hooks/useRegisterWorkflowConfigs';
import {
    WARM_WELCOME_VIDEO_SRC,
    WARM_WELCOME_IMAGE_SRC,
} from 'mini-campaign-bootstrap/lib/utils/CampaignConstants';

/**
 * Component which serves as a wrapper over the main mail module component
 * All the components which need to be fetched on boot but need not be shown for optimization purpose can be added inside the
 * div with display:'none to ensure that the component is already loaded when it needs to be invoked
 * Please note that this will load the component on boot time, adding some delay there instead of later
 *
 * @param props
 */
export default observer(function MailModuleWrapper(props: {}): JSX.Element {
    const wrapperRef = React.createRef<HTMLDivElement>();
    const { mailWarmWelcomeJourney, mailWarmWelcomeCampaign } = getMailCampaignObjects();

    // register workflow configs
    useRegisterWorkflowConfigs(lazyRegisterMailWorkflowConfigs.importAndExecute);

    // refresh mail-list data if the app was in the background for a long time
    useRefreshMailListOnVisibilityChange();

    return (
        <RouteStateContextProvider>
            <div ref={wrapperRef} tabIndex={0} role="main" aria-label={strings.moduleMailLabel}>
                <Router basename={getMailPath()}>
                    <MiniNavigationContextProvider>
                        <MailModule />
                        <AriaLiveWrapper />
                        {mailWarmWelcomeCampaign === null ? null : (
                            <mailWarmWelcomeCampaign.unit
                                journey={mailWarmWelcomeJourney}
                                campaignViewTypeProps={{
                                    title: commonStrings.warmWelcomeModalTitle,
                                    subtitle: commonStrings.warmWelcomeModalSubtitle,
                                    videoSrc: WARM_WELCOME_VIDEO_SRC,
                                    imageSrc: WARM_WELCOME_IMAGE_SRC,
                                    primaryButtonText: commonStrings.warmWelcomeModalButton,
                                    elementToFocusOnClose: wrapperRef,
                                }}
                            />
                        )}
                    </MiniNavigationContextProvider>
                </Router>
            </div>
        </RouteStateContextProvider>
    );
});
